import axios from "axios";

const pre_url =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_API_URL || "https://etsy.wbapi.systems"
    : "";

export default axios.create({
  baseURL: pre_url,
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
